import { render, staticRenderFns } from "./message.vue?vue&type=template&id=476ca24f&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style1 from "./message.vue?vue&type=style&index=1&id=476ca24f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ca24f",
  null
  
)

export default component.exports